export default "/fonts/vendor/katex/dist/KaTeX_Math-Italic.woff?96759856b4e70f3a83385d07e0d33b03";